import mapActions from "actions/map";
import modalActions from "actions/modal";
import { Map as SharedMap } from "components/map/shared";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const MapContainer = (props) => {
    const { tileUrls, center, zoom } = props;
    return (
        <SharedMap viewport={{ center, zoom }} tileUrls={tileUrls} zoomControl={false}>
            {props.children}
        </SharedMap>
    );
};

const mapStateToProps = (state) => ({
    viewport: state.map.viewport,
    data: state.map.data,
    fullscreen: state.layout.fullscreen,
    tileUrls: state.configs.tileUrls,
    params: state.map.params,
    organizationTimezone: state.profile.timezone,
    roles: state.profile.roles,
    enums: state.dictionaries.enums,
    profile: state.profile.profile,
    header: state.map.header,
});

const mapDispatchToProps = (dispatch) => ({
    switchMap: (params) => dispatch(mapActions.switchMap(params)),
    mergeMapViewport: (params) => dispatch(mapActions.mergeMapViewport(params)),
    mergeMapData: (data) => dispatch(mapActions.mergeMapData(data)),
    changeCenter: (data) => dispatch(mapActions.changeCenter(data)),
    mergeParams: (data) => dispatch(mapActions.mergeParams(data)),
    modal: (params) => dispatch(modalActions.open(params)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MapContainer));
